import { useStoreData } from "@/components/Common/useStoreData";
import { ref, computed, Ref, watch } from "vue";
import { useStoreDataCloud } from "@/components/Cloud/Dashboard/useStoreData";
import i18n from "@/plugins/i18n";
import { AlertData, ObjectsMapper, Subscriptions } from "./cloud.all.types";

export function useTopAlertsByMetrics(
  subscriptions: Ref<Subscriptions[]>,
  getAlertMatricNameMapper: Ref<ObjectsMapper>
) {
  const { getDurationTime } = useStoreData();
  const { getTopAlertsPerInstances } = useStoreDataCloud();
  const alertData = ref<AlertData[]>([]);

  const fetchTopAlerts = async () => {
    const alerts: { [metricName: string]: number }[] = [];

    for (let subscription of subscriptions.value) {
      try {
        const response = await getTopAlertsPerInstances({
          condition: {
            entity: { scope: "Service", serviceName: subscription.key },
          },
          duration: getDurationTime.value,
        });

        const matrices = response?.data?.getTopMetricsByAlerts?.values;
        if (matrices) {
          const subscriptionMetrics: { [key: string]: number } = {};
          for (let matric of matrices) {
            subscriptionMetrics[matric.metricName] = matric.alertCount;
          }

          alerts.push(subscriptionMetrics);
        }
      } catch (error) {
        console.error("Error fetching top alerts:", error);
      }
    }

    let totalAlerts: { [key: string]: number } = {};

    for (let individualMetrics in getAlertMatricNameMapper.value) {
      
      totalAlerts[individualMetrics] = alerts.reduce(
        (currentAlert, accumulator) =>
          accumulator[individualMetrics]
        ? currentAlert + accumulator[individualMetrics]
        : currentAlert,
        0
      );
    }

    const totalAlertsData = Object.entries(totalAlerts)
      .map(([key, value]) => ({
        alerts: value,
        metrics: i18n.global.t(
          `aws.alertsTable.${getAlertMatricNameMapper.value[key]}`
        ),
      }))
      .filter((alert) => alert.alerts)
      .sort((a: AlertData, b: AlertData) => b.alerts - a.alerts);

    alertData.value = totalAlertsData;
  };

  return {
    alertData: alertData,
    fetchTopAlerts,
  };
}
